"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var spinner_1 = __importDefault(require("../spinner"));
var ButtonContent = function (props) {
    var leftIcon = props.leftIcon, rightIcon = props.rightIcon, children = props.children;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [leftIcon && (0, jsx_runtime_1.jsx)(ButtonIcon, { children: leftIcon }), children, rightIcon && (0, jsx_runtime_1.jsx)(ButtonIcon, { children: rightIcon })] }));
};
var ButtonIcon = function (props) {
    var children = props.children, rest = __rest(props, ["children"]);
    var _children = react_1.default.isValidElement(children)
        ? react_1.default.cloneElement(children, {
            'aria-hidden': true,
            focusable: false,
        })
        : children;
    return ((0, jsx_runtime_1.jsx)("span", __assign({ "data-sr-button-icon": true }, rest, { children: _children })));
};
var Button = function (_a) {
    var children = _a.children, isLoading = _a.isLoading, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, disabled = _a.disabled, rest = __rest(_a, ["children", "isLoading", "leftIcon", "rightIcon", "disabled"]);
    var contentProps = { rightIcon: rightIcon, leftIcon: leftIcon, children: children };
    return ((0, jsx_runtime_1.jsx)("button", __assign({ "data-sr-button": true }, rest, { disabled: isLoading || disabled, children: isLoading ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ButtonIcon, { children: (0, jsx_runtime_1.jsx)(spinner_1.default, {}) }), (0, jsx_runtime_1.jsx)("span", { className: "sr-only", children: "Loading" })] })) : ((0, jsx_runtime_1.jsx)(ButtonContent, __assign({}, contentProps))) })));
};
exports.default = Button;
